export type TableHeader = { label: string; value: string; key: string };

const getTableHeaders = (): TableHeader[] => {
  return [
    {
      label: 'date',
      value: 'date',
      key: 'date',
    },
    {
      label: 'country',
      value: 'country',
      key: 'country',
    },
    {
      label: 'city',
      value: 'city',
      key: 'city',
    },
    {
      label: 'name',
      value: 'tourName',
      key: 'tourName',
    },
    {
      label: 'venue',
      value: 'venue',
      key: 'venue',
    },
  ];
};

export default getTableHeaders;
